// extracted by mini-css-extract-plugin
module.exports = {"formClass":"oI","setupPinButton":"oJ","submitButton":"oK","cancelButton":"oL","enterPinHelpText":"oM"};